import { Component, computed, effect, ElementRef, HostListener, input, output, signal, ViewChild, viewChild } from '@angular/core';
import { IconCloseComponent } from '../icon-close/icon-close.component';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { CdkTrapFocus } from '@angular/cdk/a11y';

@Component({
  selector: 'app-slide-out',
  standalone: true,
  imports: [IconCloseComponent, CdkTrapFocus],
  templateUrl: './slide-out.component.html',
  styleUrl: './slide-out.component.scss',
  animations: [
    trigger('slideInOut', [
      state('void', style({ transform: 'translateX(100vw)', visibility: 'hidden' })), // Initial state
      state('open', style({ transform: 'translateX(0)', visibility: 'visible' })), // Open state
      transition('void => open', [
        style({ visibility: 'visible' }), // Set visibility immediately
        animate('225ms cubic-bezier(0.4, 0, 0.2, 1)', style({ transform: 'translateX(0)' })),
      ]),
      transition('open => void', [
        animate('225ms cubic-bezier(0.4, 0, 0.2, 1)', style({ transform: 'translateX(100vw)' })),
      ]),
    ]),
  ],
})
export class SlideOutComponent {
  isSlideOutOpen = input.required<boolean>();
  title = input.required<string>();
  description = input<string>();
  slideOutAnimationState = computed(() => (this.isSlideOutOpen() ? 'open' : 'void'));
  closeSlideOut = output();

  closeBtnRef = viewChild<ElementRef>('closeBtnRef');
  previouslyFocusedEl: HTMLElement;

  @ViewChild('sidebar') panelRef!: ElementRef;
  @HostListener('document:mousedown', ['$event'])
  handleClick(event: MouseEvent) {
    const clickedInside = this.panelRef.nativeElement.contains(event.target);
    
    // Check if the click is on a dialog backdrop or dialog content opened on top of the slide out
    const target = event.target as HTMLElement;
    const isDialogClick = target.closest('.disclosure-dialog') || 
                          target.closest('.disclosure-backdrop');
    
    if (!clickedInside && this.isSlideOutOpen() && !isDialogClick) {
      this.closeSlideOut.emit();
    }
  }

  constructor() {
    effect(() => {
      const isSlideOutOpen = this.isSlideOutOpen();
      if (isSlideOutOpen) {
        this.previouslyFocusedEl = document.activeElement as HTMLElement;
        this.closeBtnRef().nativeElement.focus({ preventScroll: true });
      } else {
        if (this.previouslyFocusedEl) {
          this.previouslyFocusedEl.focus({ preventScroll: true });
        }
      }
    });
  }
}
